<template>
  <InfiniteScroll
    @reached="fetchCourses"
    :is-done="isDone"
    :is-loading="isLoading"
  >
    <slot v-bind="{ courses, isLoading }"/>

    <NoRecordsInlineText v-if="!isLoading && !courses.length">
      Sem cursos em progresso no momento :|
    </NoRecordsInlineText>
  </InfiniteScroll>
</template>

<script>
import { getUserCoursesOngoing } from '@/api/course.api'
import InfiniteScroll from '../../layout/InfiniteScroll.vue'
import NoRecordsInlineText from '../../text/NoRecordsInlineText.vue'

export default {
  components: { InfiniteScroll, NoRecordsInlineText },

  props: {
    user: { type: Object, required: true },
    pageLimit: { type: Number, default: 999 },
    perPage: { type: Number, default: 5 }
  },

  data: () => ({
    courses: [],
    page: 1,
    isDone: false,
    isLoading: false,
  }),

  methods: {
    async fetchCourses () {
      this.isLoading = true

      const res = await getUserCoursesOngoing(this.user.id, {
        perPage: this.perPage,
        page: this.page++
      })

      this.isDone = this.pageLimit > this.page || !res.links.next

      res.data.forEach(course => this.courses.push(course))

      this.isLoading = false
    }
  }
}
</script>